import { render, staticRenderFns } from "./clientSuccessfullyRegistered.vue?vue&type=template&id=45cfa1c2&scoped=true&"
import script from "./clientSuccessfullyRegistered.vue?vue&type=script&lang=js&"
export * from "./clientSuccessfullyRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfa1c2",
  null
  
)

export default component.exports